// @flow

// Displays clickable text with a tap target that fits the text, regardless of parent container style

import React from 'react';
import { Box, Text, Touchable } from 'gestalt';

type Props = {|
  color?: 'darkGray' | 'gray',
  handleClick: () => void,
  size?: 'sm' | 'md' | 'lg',
  text: string,
|};

export default function TextButton({ color = 'gray', handleClick, size = 'sm', text }: Props) {
  return (
    <Box display="inlineBlock">
      <Touchable onTouch={handleClick} shape="pill">
        <Text color={color} size={size} weight="bold">
          {text}
        </Text>
      </Touchable>
    </Box>
  );
}
